import { render } from "./MoodPage.vue?vue&type=template&id=f98d1280"
import script from "./MoodPage.vue?vue&type=script&lang=js"
export * from "./MoodPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__